<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          v-if="['变更申请'].includes(onlyOneChild.meta.title)"
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
          style="padding-left: 23px !important"
        >
          <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
        </el-menu-item>
        <el-menu-item
          v-else
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template v-slot:title>
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from './Item';
import AppLink from './Link';
import FixiOSBug from './FixiOSBug';

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        }
        // 检查菜单权限
        const userList = JSON.parse(localStorage.getItem('userList'));
        if (item.meta && item.meta.title === '权限管理') {
          const userId = localStorage.getItem('UserId');
          const allowedUsers = ['卢旭', '朱泳仪', '周德明', '韩林达', '何文卷', '陈伟锋'];
          if (!allowedUsers.includes(userId)) {
            item.hidden = true;
            return false;
          }
        }
        if (
          item.meta &&
          userList &&
          (item.meta.title === '员工信息' || item.meta.title === '资源管理')
        ) {
          const userId = localStorage.getItem('UserId');
          const currentUser = userList.find((user) => user.name === userId);
          if (!currentUser || !currentUser.menuName.includes(item.meta.title)) {
            item.hidden = true;
            return false;
          }
        }
        if (item.meta && item.meta.title === '技术改造') {
          const appid = localStorage.getItem('appid');
          const corpName = localStorage.getItem('corpName');
          // 检查 corpName 和 appid 是否满足条件
          if (!corpName || corpName !== 'fontal' || !appid || appid !== 'wwb3f3f6dfceb2618d') {
            item.hidden = true;
            return false;
          }
        }

        // 只有通过权限检查的菜单项才会被设置为onlyOneChild
        this.onlyOneChild = item;
        return true;
      });

      if (showingChildren.length === 1 && !parent.meta.alwaysShow) {
        return true;
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
  },
};
</script>
